function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { j as r } from "./index.es33.js";
import { useRef as a, useEffect as n } from "react";
import { clsx as p } from "./index.es105.js";
import "./index.es133.js";
import { Portal as c } from "./index.es168.js";
import { ModalWrapper as l } from "./index.es207.js";
import "./index.es134.js";
import { Typography as f } from "./index.es35.js";
import "./index.es36.js";
import { useClickAway as d } from "./index.es130.js";
import e from "./index.es213.js";
var A = function A(_ref) {
  var i = _ref.title,
    t = _ref.onClose,
    _ref$isLarge = _ref.isLarge,
    s = _ref$isLarge === void 0 ? !1 : _ref$isLarge,
    m = _ref.children;
  var o = a(null);
  return d(o, t, {
    isExcludeTargets: !0
  }), n(function () {
    return window.addEventListener("popstate", t), function () {
      requestAnimationFrame(function () {
        return window.removeEventListener("popstate", t);
      });
    };
  }, []), r.jsx(l, {
    modalRef: o,
    children: r.jsx(c, {
      children: r.jsx("div", {
        className: e.overlay,
        children: r.jsxs("div", {
          className: p(e.container, _defineProperty({}, e.containerBig, s)),
          ref: o,
          children: [i && r.jsx(f.Heading7, {
            className: e.title,
            children: i
          }), m]
        })
      })
    })
  });
};
export { A as Confirm };